module.exports = __webpack_public_path__ + "img/djxx_banner.3b6fba0e.png";